module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shop-cars"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.shopObj.nickName) + " 还有\n        "), _c('div', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectShop()
      }
    }
  }, [_vm._v("查看更多")])])]), _vm._v(" "), _c('div', {
    staticClass: "shop-cars-list"
  }, [_vm._l((_vm.carsRows), function(row) {
    return _vm._l((row.childArr), function(item) {
      return _c('div', {
        staticClass: "car-item-container"
      }, [_c('a', {
        attrs: {
          "href": '/car/' + item.id
        }
      }, [_c("CarItem", {
        tag: "div",
        class: ['line-height-level-' + row.lineHeightLevel],
        attrs: {
          "data": item
        }
      })])])
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39d5c7f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/ListMain/OtherShop/ShopCars.vue
// module id = 850
// module chunks = 5